import React from 'react'

export const prismicLink = (type: string, element: any, content: JSX.Element): JSX.Element => {
  console.log('element', element)

  return (
    <a href={element.data.url} target={'_blank'} rel={'noopener noreferrer'} style={{ color: '#FFF' }}>
      {content}
    </a>
  )
}
